/**
 * Gallery like styled lightbox component for presenting various types of media
 * @requires https://github.com/biati-digital/glightbox
 */

export default (() => {
  const lightboxEl = document.querySelector("[data-glightbox]");

  if (lightboxEl === null) return;

  // Check the dir attribute on html tag and set the default to "ltr" if it's not set or invalid
  const htmlElement = document.documentElement;
  const dir = htmlElement.getAttribute("dir");
  const direction = dir === "ltr" || dir === "rtl" ? dir : "ltr";

  const cssEffects =
    direction === "rtl"
      ? {
          slide: { out: "slideOutRight", in: "slideInLeft" },
          slideBack: { out: "slideOutLeft", in: "slideInRight" },
        }
      : {
          slide: { out: "slideOutLeft", in: "slideInRight" },
          slideBack: { out: "slideOutRight", in: "slideInLeft" },
        };

  /* eslint-disable no-unused-vars, no-undef */
  const lightbox = GLightbox({
    selector: "[data-glightbox]",
    openEffect: "fade",
    closeEffect: "fade",
    slideEffect: "slide",
    closeOnOutsideClick: true,
    videosWidth: "1200px",
    draggable: direction !== "rtl",
    touchNavigation: direction !== "rtl",
    cssEfects: cssEffects,
    onOpen: () => {
      // Add click handler to overlay when lightbox opens
      const overlay = document.querySelector(".goverlay");
      if (overlay) {
        overlay.addEventListener("click", handleOverlayClick);
      }
    },
    onClose: () => {
      // Remove click handler when lightbox closes
      const overlay = document.querySelector(".goverlay");
      if (overlay) {
        overlay.removeEventListener("click", handleOverlayClick);
      }
    },
  });
  /* eslint-enable no-unused-vars, no-undef */

  // Handler for overlay clicks
  function handleOverlayClick(e) {
    // Only close if clicking directly on the overlay, not on child elements
    if (e.target === e.currentTarget) {
      lightbox.close();
    }
  }
})();
